// quiron/frontend/src/components/MaterialResultModal.js

import React from 'react';
import ReactDOM from 'react-dom';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import { useTranslation } from 'react-i18next';
import styles from './MaterialResultModal.module.css';

const MaterialResultModal = ({ isOpen, onClose, result, sourceName, sourceType }) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  const contentToDisplay = result?.transcription || result?.summary || JSON.stringify(result, null, 2);

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div>
            <h3 className={styles.modalTitle}>{t('materialResult')}</h3>
            <p className={styles.modalSubtitle}>{`${t('base')}: ${sourceType} - ${sourceName}`}</p>
          </div>
          <button onClick={onClose} className={styles.closeButton}>×</button>
        </div>
        <div className={styles.modalBody}>
          <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
            {contentToDisplay}
          </ReactMarkdown>
        </div>
        <div className={styles.modalFooter}>
            <button onClick={onClose} className={styles.footerCloseButton}>{t('close')}</button>
        </div>
      </div>
    </div>,
    document.getElementById('result-portal') // Usando o portal existente
  );
};

export default MaterialResultModal;